import { render } from "./CertDetailPage.vue?vue&type=template&id=14edfc15&scoped=true&ts=true"
import script from "./CertDetailPage.vue?vue&type=script&lang=ts"
export * from "./CertDetailPage.vue?vue&type=script&lang=ts"

import "./CertDetailPage.vue?vue&type=style&index=0&id=14edfc15&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14edfc15"]])

export default __exports__